var _rect, _path, _rect2, _rect3, _rect4, _rect5, _path2, _path3, _rect6, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHotbar(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 32,
    viewBox: "0 0 38 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.593018,
    y: 0.460938,
    width: 17,
    height: 14.5,
    rx: 4,
    fill: "#90CAF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.593 9.79542V11.4616C16.593 12.1245 16.2769 12.7602 15.7143 13.2289C15.1517 13.6976 14.3887 13.9609 13.593 13.9609H4.59302C3.79737 13.9609 3.03431 13.6976 2.4717 13.2289C1.90909 12.7602 1.59302 12.1245 1.59302 11.4616V9.79542C1.59302 9.79542 1.59302 9.79542 1.59302 9.74544C1.60572 9.66302 1.6292 9.58201 1.66302 9.50384C1.66302 9.50384 1.66302 9.43719 1.66302 9.40386C1.73358 9.29768 1.82875 9.20423 1.94302 9.12894L5.94302 6.62963C6.13548 6.50834 6.3741 6.44912 6.61486 6.4629C6.85562 6.47668 7.08227 6.56253 7.25302 6.70461L9.67302 8.72072L11.993 7.43774C12.1563 7.34816 12.3475 7.30042 12.543 7.30042C12.7385 7.30042 12.9297 7.34816 13.093 7.43774L16.093 9.10395C16.1951 9.15578 16.2808 9.22719 16.343 9.31222L16.393 9.36221C16.4533 9.44078 16.4941 9.52858 16.513 9.62047C16.5177 9.6369 16.5177 9.65402 16.513 9.67046C16.5451 9.70952 16.572 9.75144 16.593 9.79542Z",
    fill: "#4CAF50"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.593,
    y: 0.460938,
    width: 17,
    height: 14.5,
    rx: 4,
    fill: "#90CAF9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.593,
    y: 9.46094,
    width: 7,
    height: 2,
    rx: 1,
    fill: "#2196F3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25.593,
    y: 6.46094,
    width: 7,
    height: 2,
    rx: 1,
    fill: "#2196F3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 25.593,
    y: 3.46094,
    width: 7,
    height: 2,
    rx: 1,
    fill: "#2196F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6699 17.4609H24.5161C22.3494 17.4609 20.593 19.2314 20.593 21.4155V28.0064C20.593 30.1904 22.3494 31.9609 24.5161 31.9609H33.6699C35.8366 31.9609 37.593 30.1904 37.593 28.0064V21.4155C37.593 19.2314 35.8366 17.4609 33.6699 17.4609Z",
    fill: "#F44336"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9662 24.2942L32.0622 23.5856C32.3996 23.3675 32.5683 23.2584 32.707 23.2723C32.828 23.2844 32.9385 23.3518 33.0103 23.4574C33.093 23.5785 33.093 23.7906 33.093 24.2145V26.2074C33.093 26.6313 33.093 26.8433 33.0105 26.9643C32.9385 27.0699 32.8281 27.1373 32.7071 27.1494C32.5683 27.1633 32.3996 27.0543 32.0624 26.8362L30.9664 26.1275M26.9542 27.9609H29.6052C30.0817 27.9609 30.3199 27.9609 30.5019 27.861C30.6619 27.7731 30.7921 27.6329 30.8736 27.4604C30.9664 27.2644 30.9664 27.0076 30.9664 26.4942V23.9276C30.9664 23.4142 30.9664 23.1575 30.8736 22.9614C30.7921 22.789 30.6619 22.6488 30.5019 22.5609C30.3198 22.4609 30.0816 22.4609 29.6052 22.4609H26.9542C26.4777 22.4609 26.2395 22.4609 26.0575 22.5609C25.8975 22.6488 25.7673 22.789 25.6858 22.9614C25.593 23.1575 25.593 23.4142 25.593 23.9276V26.4944C25.593 27.0078 25.593 27.2645 25.6858 27.4606C25.7673 27.633 25.8975 27.7733 26.0575 27.8611C26.2395 27.9609 26.4777 27.9609 26.9542 27.9609Z",
    fill: "#D32F2F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.593018,
    y: 17.4609,
    width: 17,
    height: 14.5,
    rx: 4,
    fill: "#2196F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84344 27.4914C7.6094 27.4921 7.37984 27.4271 7.18091 27.3038C7.00076 27.1912 6.85228 27.0346 6.74948 26.8487C6.64668 26.6628 6.59296 26.4537 6.59338 26.2413V23.7412C6.58802 23.5192 6.64187 23.2998 6.7494 23.1056C6.85693 22.9113 7.01426 22.7492 7.2052 22.6359C7.39615 22.5226 7.61382 22.4622 7.83585 22.461C8.05787 22.4597 8.27623 22.5175 8.46847 22.6286L10.9686 23.8787C11.1733 23.9836 11.3452 24.143 11.4652 24.3393C11.5852 24.5356 11.6487 24.7612 11.6487 24.9912C11.6487 25.2213 11.5852 25.4469 11.4652 25.6432C11.3452 25.8395 11.1733 25.9989 10.9686 26.1038L8.46847 27.3538C8.27559 27.4531 8.06019 27.5005 7.84344 27.4914Z",
    fill: "#1B7CC9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotbar);
export default __webpack_public_path__ + "static/media/Hotbar.37de56792e4edfe66e5bd53196a4edbe.svg";
export { ForwardRef as ReactComponent };